module.exports = ".video-empty {\n  background-color: #000000; }\n  .video-empty.size-s {\n    width: 560px;\n    height: 315px; }\n  .video-empty.size-m {\n    width: 640px;\n    height: 360px; }\n  .video-empty.size-l {\n    width: 853px;\n    height: 480px; }\n  .video-empty.size-xl {\n    width: 1280px;\n    height: 720px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/youtube-player/youtube-player.component.scss
// module id = ./libs/atenea-cms/src/youtube-player/youtube-player.component.scss
// module chunks = main